import {computed, inject} from '@angular/core';
import {rxResource} from '@angular/core/rxjs-interop';
import {signalStore, withComputed, withMethods, withProps} from '@ngrx/signals';
import {TeamApi} from "../../../../../core/data/team/team.api";

export const TeamStore = signalStore(
  withProps((store, teamApi = inject(TeamApi)) => {
    return {
      _team: rxResource({
        stream: () => teamApi.getTeam(),
      })
    };
  }),
  withComputed(({_team}) => {
    return {
      // Exposed Data Signals
      isLoading: computed(() => _team.isLoading()),
      team: computed(() => _team.value() || []),
    }
  }),
  withMethods((store) => ({
    reload: () => {
      if (store._team.error()) {
        store._team.reload();
      }
    },
  })),
);
